import { ISubscription } from '@modules/subscriptions/interfaces/ISubscription';
import IClass from '@modules/classes/interfaces/IClass';

export const formatEnrollment = (subscription: ISubscription[], classToAdd: IClass | undefined) => {
  const aux = [] as any[];
  subscription.forEach((sub) => aux.push({ student_id: sub.student?.id, subscription_id: sub.id, class_id: classToAdd?.id }));
  return aux;
};
